/*
 * @Author: lzy
 * @Date: 2021-04-25 11:13:05
 * @LastEditTime: 2021-04-25 16:29:21
 * @LastEditors: lzy
 * @Description: 推荐渠道
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\recommendedChannels\recommendedChannelsCtrl.js
 */

angular.module('recommendedChannelsModule', []).directive('recommendedChannels', ['iWoService',
    function(iWoService) {
        return {
            scope: true,
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/recommendedChannels/recommendedChannels.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        selectedRecommendedChannels: []
                    };
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    getRecommendedChannels();
                }

                /**
                 * [getRecommendedChannels description] 获取推荐渠道
                 *
                 * @return  {[type]}   [return description]
                 */
                function getRecommendedChannels() {
                    $scope.loadingPromise = iWoService.getProducts().then((data) => {
                        $scope.data.recommendedChannels = data;
                    });
                }

                $scope.selectedRecommendedChannel = function(channel) {
                    $scope.data.selectedRecommendedChannels = $scope.list.DOCSHAREMEDIA ? $scope.list.DOCSHAREMEDIA.split(',') : [];
                    var index = $scope.data.selectedRecommendedChannels.indexOf(channel.MEDIATYPE);
                    if (index > -1) {
                        $scope.data.selectedRecommendedChannels.splice(index, 1);
                    } else {
                        $scope.data.selectedRecommendedChannels.push(channel.MEDIATYPE);
                    }
                    $scope.list.DOCSHAREMEDIA = $scope.data.selectedRecommendedChannels.join(',');
                };

                $scope.isChecked = function(channel) {
                    return $scope.list && $scope.list.DOCSHAREMEDIA && $scope.list.DOCSHAREMEDIA.split(',').indexOf(channel.MEDIATYPE) !== -1;
                };
            }
        };
    }
]);
